export interface PrevJob {
  place: string;
  title: string;
}

export interface TeamMember {
  translatorKey: string;
  img: string;
  name: string;
  job: string;
  prevJob: PrevJob[];
  icons: string[];
}

export interface TeamProps {
  members: TeamMember[];
}

export const TeamData: TeamProps = {
  members: [
    {
      translatorKey: 'jorge',
      img: '/landing_page/img/team/jorge-azulclaro.webp',
      name: 'Jorge de la Carrera',
      job: 'Co-fundador & CTO',
      prevJob: [
        { place: 'Meta', title: 'Software Engineer' },
        { place: 'PUC', title: 'Ingeniero Civil Computación' },
      ],
      icons: ['/landing_page/img/team/meta.webp', '/landing_page/img/team/puc.webp'],
    },
    {
      translatorKey: 'benja',
      img: '/landing_page/img/team/benja-azulclaro.webp',
      name: 'Benjamín Bustos',
      job: 'Co-fundador & CEO',
      prevJob: [
        {
          place: 'London Business School',
          title: 'MBA',
        },
        { place: 'Credicorp Capital', title: 'Investment Banking Associate' },
      ],
      icons: ['/landing_page/img/team/London.webp', '/landing_page/img/team/credi.webp'],
    },
    {
      translatorKey: 'carlos',
      img: '/landing_page/img/team/carlos-azulclaro.webp',
      name: 'Carlos Stevenson',
      job: 'Co-fundador & COO',
      prevJob: [
        {
          place: 'London Business School',
          title: 'MBA',
        },
        { place: 'Banco Bice', title: 'Wealth Management Advisor' },
      ],
      icons: ['/landing_page/img/team/London.webp', '/landing_page/img/team/bice.webp'],
    },
    {
      translatorKey: 'juan',
      img: '/landing_page/img/team/juan-azulclaro.webp',
      name: 'Juan Cortés',
      job: 'Developer',
      prevJob: [
        { place: 'PUC', title: 'Ingeniero Industrial TI' },
        { place: 'Forcast', title: 'Full-Stack Developer' },
      ],
      icons: ['/landing_page/img/team/puc.webp', '/landing_page/img/team/forcast.webp'],
    },
    {
      translatorKey: 'tomas',
      img: '/landing_page/img/team/tomas-azulclaro.webp',
      name: 'Tomás García',
      job: 'Developer',
      prevJob: [
        { place: 'PUC', title: 'Ingeniero Civil Computación' },
        { place: 'Celcom', title: 'Software Engineer' },
      ],
      icons: ['/landing_page/img/team/puc.webp', '/landing_page/img/team/celcom.webp'],
    },
    {
      translatorKey: 'trinidad',
      img: '/landing_page/img/team/trinidad-azulclaro.webp',
      name: 'Trinidad Olivos',
      job: 'Growth & Marketing Manager',
      prevJob: [
        { place: 'Universidad De Los Andes', title: 'Administradora de servicios' },
        { place: 'Promedon', title: 'Gestión de personas' },
      ],
      icons: ['/landing_page/img/team/uandes.webp', '/landing_page/img/team/promedon.webp'],
    },
    {
      translatorKey: 'maria_jose',
      img: '/landing_page/img/team/maria-jose-azulclaro.webp',
      name: 'María José Castro',
      job: 'Chief Commercial Officer (CCO)',
      prevJob: [
        { place: 'PUC', title: 'Ingeniera Comercial' },
        { place: 'BUK', title: 'Sales Lead' },
      ],
      icons: ['/landing_page/img/team/puc.webp', '/landing_page/img/team/buk.webp'],
    },
    {
      translatorKey: 'harold',
      img: '/landing_page/img/team/harold-azulclaro.webp',
      name: 'Harold Müller',
      job: 'Developer',
      prevJob: [
        { place: 'PUC', title: 'Ingeniero Industrial TI' },
        { place: 'MACH', title: 'Software Engineer' },
      ],
      icons: ['/landing_page/img/team/puc.webp', '/landing_page/img/team/mach.webp'],
    },
    {
      translatorKey: 'anibal',
      img: '/landing_page/img/team/anibal-azulclaro.webp',
      name: 'Aníbal Contreras',
      job: 'Developer',
      prevJob: [
        { place: 'PUC', title: 'Ingeniero Industrial Computación' },
        { place: 'Aurous', title: 'Software Engineer' },
      ],
      icons: ['/landing_page/img/team/puc.webp', '/landing_page/img/team/aurous.webp'],
    },
    {
      translatorKey: 'andrea',
      img: '/landing_page/img/team/andrea-azulclaro.webp',
      name: 'Andrea Miranda',
      job: 'Key Account Manager',
      prevJob: [
        { place: 'Universidad De Los Andes', title: 'Administradora de servicios' },
        { place: 'Latam Airlines', title: 'Key Account Manager' },
      ],
      icons: ['/landing_page/img/team/uandes.webp', '/landing_page/img/team/latam.webp'],
    },
  ],
};
